import CircularProgress, { type CircularProgressProps } from '@mui/material/CircularProgress';

function Spinner({ size = 40, ...props }: CircularProgressProps) {
	return <CircularProgress size={size} {...props} />;
}

export default Spinner;
